import { useTranslation } from 'react-i18next';
import { Header, Footer } from '../components';

// Politique de confidentialité (RGPD), bilingue FR/EN. Contenu à faire relire/adapter par tes soins.
const CONTENT = {
  fr: {
    title: 'Politique de confidentialité',
    updated: 'Dernière mise à jour : 27 juillet 2026',
    html: `
      <p>KeepMyGames respecte ta vie privée. Cette page explique quelles données nous collectons, pourquoi, et comment tu peux les contrôler.</p>

      <h2>1. Données que nous collectons</h2>
      <ul>
        <li><strong>Ta liste de jeux Steam publics</strong> — uniquement lors d'un scan, via la connexion Steam officielle. Nous ne demandons <strong>jamais</strong> ton mot de passe et n'accédons qu'à ta liste de jeux publique.</li>
        <li><strong>Ton adresse email</strong> — seulement si tu t'abonnes (Pro) ou actives les alertes.</li>
        <li><strong>Statistiques de visite anonymes</strong> — nombre de visiteurs et pays d'origine. Ton adresse IP est <strong>hachée</strong> (jamais stockée en clair).</li>
        <li><strong>Les avis</strong> que tu choisis de laisser (note, commentaire, pseudo optionnel).</li>
      </ul>

      <h2>2. Cookies &amp; mesure d'audience</h2>
      <p>Avec ton consentement, nous utilisons <strong>Microsoft Clarity</strong> pour comprendre comment le site est utilisé (cartes de chaleur, enregistrements de sessions anonymisés) et l'améliorer. Ces cookies ne sont chargés <strong>que si tu cliques « Accepter »</strong> dans le bandeau. Le contenu sensible est masqué par défaut. Tu peux refuser sans aucun impact sur ton utilisation du site.</p>

      <h2>3. Paiement</h2>
      <p>Les abonnements Pro sont gérés par <strong>Stripe</strong>. Nous ne stockons pas tes données bancaires.</p>

      <h2>4. Partage des données</h2>
      <p>Nous <strong>ne vendons pas</strong> tes données. Elles ne sont partagées qu'avec les prestataires nécessaires au fonctionnement du service (Steam, Stripe, Microsoft Clarity).</p>

      <h2>5. Tes droits (RGPD)</h2>
      <p>Tu peux demander l'accès, la rectification ou la suppression de tes données à tout moment en nous écrivant à <a href="mailto:support@keepmygames.com">support@keepmygames.com</a>.</p>

      <h2>6. Contact</h2>
      <p>Une question sur tes données ? Écris-nous à <a href="mailto:support@keepmygames.com">support@keepmygames.com</a> ou via la <a href="/contact">page contact</a>.</p>
    `,
  },
  en: {
    title: 'Privacy Policy',
    updated: 'Last updated: July 27, 2026',
    html: `
      <p>KeepMyGames respects your privacy. This page explains what data we collect, why, and how you can control it.</p>

      <h2>1. Data we collect</h2>
      <ul>
        <li><strong>Your public Steam games list</strong> — only during a scan, via the official Steam login. We <strong>never</strong> ask for your password and only access your public games list.</li>
        <li><strong>Your email address</strong> — only if you subscribe (Pro) or enable alerts.</li>
        <li><strong>Anonymous visit statistics</strong> — number of visitors and country. Your IP address is <strong>hashed</strong> (never stored in clear text).</li>
        <li><strong>The reviews</strong> you choose to leave (rating, comment, optional nickname).</li>
      </ul>

      <h2>2. Cookies &amp; analytics</h2>
      <p>With your consent, we use <strong>Microsoft Clarity</strong> to understand how the site is used (heatmaps, anonymized session recordings) and improve it. These cookies load <strong>only if you click "Accept"</strong> in the banner. Sensitive content is masked by default. You can decline with no impact on your use of the site.</p>

      <h2>3. Payment</h2>
      <p>Pro subscriptions are handled by <strong>Stripe</strong>. We do not store your payment card details.</p>

      <h2>4. Data sharing</h2>
      <p>We <strong>do not sell</strong> your data. It is only shared with the providers needed to run the service (Steam, Stripe, Microsoft Clarity).</p>

      <h2>5. Your rights (GDPR)</h2>
      <p>You can request access, correction or deletion of your data at any time by writing to <a href="mailto:support@keepmygames.com">support@keepmygames.com</a>.</p>

      <h2>6. Contact</h2>
      <p>A question about your data? Write to <a href="mailto:support@keepmygames.com">support@keepmygames.com</a> or via the <a href="/contact">contact page</a>.</p>
    `,
  },
};

function PrivacyPage() {
  const { t, i18n } = useTranslation();
  const c = CONTENT[i18n.resolvedLanguage === 'en' ? 'en' : 'fr'];

  return (
    <div className="app-shell">
      <Header />
      <main className="app-main">
        <section className="legal">
          <a className="legal__back" href="/">{t('privacy.back')}</a>
          <h1 className="legal__title">{c.title}</h1>
          <p className="legal__updated">{c.updated}</p>
          {/* Contenu statique interne (pas d'entrée utilisateur) -> dangerouslySetInnerHTML sans risque. */}
          <div className="legal__body" dangerouslySetInnerHTML={{ __html: c.html }} />
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default PrivacyPage;
